import { theme } from '@features/executive-report/domain/theme';
import {
  TextProps,
  TextPropsTextConfig,
  parseContent,
} from '@features/powerpoint';
import { pyramidMetrics, topLevelMetrics } from './content';
import {
  applyPyramidXOffset,
  applyPyramidYOffset,
  applyTopLevelMetricXOffset,
} from './layout';
import { formatters } from '@utils/formattersV2';
import { VisitOverviewSlideOptions } from '../visit-overview';
import { staticTexts } from './static-texts';

export const texts = (options: VisitOverviewSlideOptions): TextProps[] => [
  ...staticTexts,
  {
    text: options.objectives.flatMap((objective): TextPropsTextConfig[] => [
      ...parseContent(objective),
      { text: '\n' },
    ]),
    options: {
      fontSize: 14,
      color: theme.colors.white,
      valign: 'top',
      paraSpaceAfter: 14,
      h: 2.22,
      w: 3.2,
      x: 0.55,
      y: 2.51,
    },
  },
  {
    text: formatters.currency(options.costPerIncrementalVisit, {
      decimals: 2,
    }),
    options: {
      fontSize: 32,
      color: theme.colors.inmarketGreen,
      h: 0.64,
      w: 3.19,
      x: 0.57,
      y: 5.16,
    },
  },
  ...topLevelMetrics.flatMap((metric, index): TextProps[] => [
    {
      text: parseContent(metric.label),
      options: {
        fontSize: 14,
        color: theme.colors.white,
        h: 0.34,
        w: 3.11,
        x: 4.51 + applyTopLevelMetricXOffset(index),
        y: 0.99,
      },
    },
    {
      text: metric.formatter(options.visitMetrics),
      options: {
        fontSize: 36,
        color: theme.colors.inmarketGreen,
        h: 0.71,
        w: 3.61,
        x: 4.51 + applyTopLevelMetricXOffset(index),
        y: 1.35,
      },
    },
  ]),
  ...pyramidMetrics.flatMap((metric, index): TextProps[] => [
    {
      text: metric.label.toUpperCase(),
      options: {
        fontSize: 8,
        color: theme.colors.white,
        bold: true,
        align: 'center',
        h: 0.37,
        w: 1.37,
        x: 6.7 + applyPyramidXOffset(index),
        y: 3.23 + applyPyramidYOffset(index),
      },
    },
    {
      text: metric.formatter(options.visitMetrics),
      options: {
        fontSize: 16,
        color: theme.colors.inmarketGreen,
        bold: true,
        align: 'left',
        h: 0.37,
        w: 3.26,
        x: 9.97,
        y: 3.23 + applyPyramidYOffset(index),
      },
    },
  ]),
];
